<template>
 <div>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
  </b-row>
  <br>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
  <b-card bg-variant="light">
    <b-form-group 
      label-cols-lg="3"
      label="Reference"
      label-size="lg"
      label-class="font-weight-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        label="Relevance:"
        label-cols-sm="3"
        label-align-sm="right"
        class="mb-0"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
            class="pt-2"
            v-model="attr_copy.relevance"
            :options="['background_information', 'suggested_guideline', 'required_rule', 'obtain', 'provide']"
            :aria-describedby="ariaDescribedby"
        ></b-form-radio-group>
      </b-form-group>
        <b-form-group
        label="Title:"
        label-for="nested-title"
        label-cols-sm="3"
        label-align-sm="right"
      >
        <b-form-input id="nested-title"
          v-model="attr_copy.title"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Summary:"
        label-for="nested-summary"
        label-cols-sm="3"
        label-align-sm="right"
      >
        <vue-simplemde align="left" v-model="attr_copy.summary" ref="markdownEditor" />
      </b-form-group>
      <b-form-group
        label="URL Link:"
        label-for="nested-url-link"
        label-cols-sm="3"
        label-align-sm="right"
      >

        <b-form-input id="nested-url-link"
          v-model="attr_copy.url_link"
        ></b-form-input>
      </b-form-group>

    </b-form-group>
    <br>
  </b-card>
  </b-col>
  <b-col md="1">
    <data-operations
      :modified="modified"
      :can_update="canUpdate"
      :can_delete="canDelete"
      :can_help="canHelp"
      @update="doUpdate"
      @undo="doUndo"
      @delete="doDelete"
      @cancel="doCancel"
      @help="doHelp"
    ></data-operations>
  </b-col>
  </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import {belongsToDescription} from '@/utils'
import DataOperations from './DataOperations.vue'
import VueSimplemde from 'vue-simplemde'

export default {
  components: {
    DataOperations,
    VueSimplemde
  },
  props: {
    id: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: 'polymorphic-references',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
    }
  },
  computed: {
    canUpdate() {
      return (this.attr_copy['reference-to-id']?.length > 0 && this.attr_copy['reference-to-type']?.length > 0 && this.attr_copy['title']?.length > 0 && this.attr_copy['summary']?.length > 0)
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
      http_v1.delete (
        this.apiResourcePath()
      ).then(response => {
        if( response.status == 204) {
          this.$router.go(-1)
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    doHelp() {
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.patch (
         this.apiResourcePath(), {
          ...attr_params
        }
      ).then(() => {
        this.$router.go(-1)
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.attr_copy = Object.assign( {}, response.data.data.attributes)
        this.attr_orig = Object.assign( {}, response.data.data.attributes)
        this.description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        this.$emit('gotAttrs', this.attr_copy, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>

<style>
  @import '~simplemde/dist/simplemde.min.css';
</style>